<template>
        <div>
            <template v-for="(modal, index) in $root.modals">
                <modal
                    :key="index"
                    :name="modal.name"
                    width="100px"
                    height="auto"
                    :class="modal.class"
                    :adaptive="true"
                    :scrollable="true"
                    @closed="killModal(modal)"
                >
                    <div :class="modal.padding ? 'p-3' : ''">
                        <div class="close-modal-button-container p-2 d-flex flex-row justify-content-end border-bottom" v-if="modal.closeButton">
                            <i class="fas fa-times-circle text-primary" @click="closeModal(modal)"></i>
                        </div>
                        <component
                            :is="modal.component"
                            v-bind="modal.bind"
                            :host="host"
                            :colors="colors"
                            @closemodal="modal.callback"
                        >
                        </component>
                    </div>
                </modal>
            </template>
        </div>
</template>

<script>


export default {
    props: ['host', 'colors'],
    methods: {
        killModal(modal) {
            _.remove(this.$root.modals, (item) => {
                return item.name = modal.name;
            });
        },
        closeModal(modal) {
            this.$modal.hide(modal.name);
        }
    },
}
</script>

<style lang="css" scoped>
    .close-modal-button-container i {
        cursor: pointer;
        font-size: 1.5em;
    }

    .v--modal-box {
        z-index: 1050;
    }
</style>
